var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ship.type === 'tanker' || _vm.ship.type === 'bulk carrier')?_c('ship-bulk',{attrs:{"ship":_vm.ship,"view":"plan"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }